import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import i18n from './i18n'
import axios from "axios";
Vue.config.productionTip = false

// 挂载到 Vue 原型
Vue.prototype.$axios = axios

Vue.use(ElementUI)
router.afterEach((to,from, next) => {
  window.scrollTo(0,0)
})

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App)
})